<template>
  <common-panel
    id="new-announce-details"
    :ifShowTitle="false"
  >
    <div class="announce-title">{{instanceInfo.afficheTitle}}</div>
    <div class="announce-time">{{momentDate(instanceInfo.createTime)}}</div>
    <div v-html="contentInfo.afficheContent"></div>
    <div class="enclosure" v-if="attachFileName">
      <span>附件：</span>
      <a :href="hrefLink">{{attachFileName}}</a>
    </div>
  </common-panel>
</template>

<script>
import CommonPanel from "@/components/common-panel/index"
import host from '@/utils/host'
import moment from 'moment'
export default {
  props: {
    afficheId: {
      type: Number,
      default: 0
    }
  },
  components: {
    CommonPanel
  },
  data() {
    return {
      contentInfo: {},
      instanceInfo:{},
      attachFileName: ''
    }
  },
  async created () {
    const jsonRes = await this.$store.dispatch('getAfficheDetails',this.afficheId)
    this.contentInfo = (jsonRes && jsonRes.data && jsonRes.data.contentInfo) ? jsonRes.data.contentInfo : {}
    this.attachFileName = (jsonRes && jsonRes.data && jsonRes.data.attachFileName) ? jsonRes.data.attachFileName : ''
    this.instanceInfo = (jsonRes && jsonRes.data && jsonRes.data.instanceInfo) ? jsonRes.data.instanceInfo : {}
  },
  computed: {
    hrefLink() {
      return `${host.hbpnotice}/hbp-notice/hbppc/common/kfsclient/download.do?fileName=${this.attachFileName}&uri=${this.contentInfo.attachmentFileUri}`
    }
  },
  methods:{
    momentDate(time) {
      return moment(time).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
.announce-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.announce-time {
  color: red;
  font-weight: bold;
  text-align: right;
  margin-right: 200px;
  margin-top: 20px;
}
.enclosure {
  margin-top: 40px;
  span {
    font-size: 12px;
    font-weight: bold;
  }
  a {
    text-decoration: underline;
  }
}
</style>
